import React from "react";
import { useNavigate } from "react-router-dom";
import YesNoRadioField from "../yes-no-radio-field/YesNoRadioField";

interface HealthQuestionFieldProps {
    question: string;
    name: string;
    value: boolean | null | undefined;
    onChange?: (value: boolean) => void;
    error?: string;
    yesId?: string;
    noId?: string;
    showEdit?: boolean;
    editRoute?: string;
}

/**
 * Health question field with optional edit link (for nicotine question)
 */
const HealthQuestionField = ({
    question,
    name,
    value,
    onChange = () => {},
    error,
    yesId,
    noId,
    showEdit = false,
    editRoute,
}: HealthQuestionFieldProps) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col gap-2">
            <p className="text-base-content">{question}</p>
            <div className="flex flex-col">
                <YesNoRadioField
                    name={name}
                    value={value}
                    onChange={onChange}
                    error={error}
                    yesId={yesId}
                    noId={noId}
                    disabled={showEdit}
                />
            </div>
            {showEdit && editRoute && (
                <button
                    onClick={() => navigate(editRoute)}
                    className="text-edit-link font-bold text-sm leading-5 hover:underline self-start"
                >
                    Edit
                </button>
            )}
        </div>
    );
};

export default HealthQuestionField;
